// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { quartersToMonths as fn } from "../quartersToMonths.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const quartersToMonths = convertToFP(fn, 1);

// Fallback for modularized imports:
export default quartersToMonths;
